/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Menu,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import { useNavigate, useParams } from "react-router-dom";
import { MdOutlineWatchLater } from "react-icons/md";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import DataTable from "react-data-table-component";
import { useEffect, useState } from "react";
import { useTMutation } from "../../../utils/useTMutation";
import showToast from "../../../components/Hot-Toast/showToast";
import { useTQuery } from "../../../utils/useTQuery";

const ViewClinicianTimeSheet = () => {
  let view = false;
  const dispatch = useDispatch();
  const { USER_ID, COMMON_ID } = useParams();
  const navigate = useNavigate();
  const { jobData } = useSelector((state) => state.job);
  const [approvedTimeSheet, setApprovedTimesheet] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [rows, setRows] = useState([]);
  const [timeSheetData, setTimeSheetData] = useState([]);
  const [openPopup, handlePopupClose] = useState(false);
  const { mutateAsync } = useTMutation(
    "/job/addUpdateTimeSheet",
    "post",
    (data) => {
      return data;
    }
  );

  const [timeValiue, setTime] = useState("");
  const {
    data: fetchedSpecialties,
    refetch,
  } = useTQuery(
    ["approveTimeSheetStatus"],
    "/job/fetchJobTimeSheet",
    "post",
    { USER_ID: USER_ID, COMMON_ID: COMMON_ID, jobServiceID: "" }
  );
  useEffect(() => {
    if (fetchedSpecialties?.STATUS) {
      setTimeSheetData(fetchedSpecialties?.OUTPUT);
    } else {
      setTimeSheetData([])
    }
  }, [fetchedSpecialties]);

  useEffect(() => {
    refetch();
  }, [timeSheetData]);

  const clockInTimes = timeSheetData?.map(
    (item) => item?.WORK_TIME?.map((w) => w?.CLOCK_IN).join(", ") || "--"
  );

  const clockOutTimes = timeSheetData?.map(
    (item) => item?.WORK_TIME?.map((w) => w?.CLOCK_OUT).join(", ") || "--"
  );

  const [value, setValue] = useState({});

  const viewTimeSheet = (row) => {
    setRows(row?.WORK_TIME);
    setTime(row?.TOTAL_TIME);
    setApprovedTimesheet(row?.STATUS);
    setValue((prev) => ({ ...prev, ...row }));
    handlePopupClose(true);
  };

  const approveTimeSheet = () => {
    mutateAsync({
      userId: value?.USER_ID,
      workTypeID: value?.COMMON_ID,
      jobServiceID: value?.job_service_ID,
      approveTimeSheetStatus: "Approved", // Toggle based on current state
      workType: "Job"
    });

    showToast("success", "Time Sheet Uploded successfully", 3000);
    setTimeout(() => {
      console.log("triggered");
      refetch();
    }, 200);

    handlePopupClose(false);
  };

  const jobDate = localStorage.getItem("jobDate");

  let columns = [
    {
      name: "Job Date",
      // selector: (row) => new Date(row?.job_service?.JOB_DATE).toDateString(),
      selector: (row) => {
        const dateValue = row?.job_service?.JOB_DATE || jobDate;
        return dateValue ? new Date(dateValue).toDateString() : "--";
      },

      reorder: true,
      sortable: true,
    },

    {
      name: "Job In",
      selector: (row, index) =>
        row?.job_service?.JOB_IN_TIME || clockInTimes?.[index] || "--",
      reorder: true,
      sortable: true,
    },
    {
      name: "Job Out",
      selector: (row, index) =>
        row?.job_service?.JOB_OUT_TIME || clockOutTimes?.[index] || "--",
      reorder: true,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.STATUS,
      reorder: true,
      sortable: true,
    },
    {
      name: "ACTIONS",
      button: true,
      cell: (row) => (
        <div style={{ paddingLeft: "15px" }}>
          <Tooltip title="View Application">
            <IconButton
              size="small"
              onClick={() => {
                viewTimeSheet(row);
              }}
            >
              <MoreHorizIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
      reorder: true,
      center: true,
    },
  ];


  let col = [
    {
      name: "Work Type",
      selector: (row) => row?.Time_Entry,
      reorder: true,
      sortable: true,
    },
    {
      name: "Clock In",
      selector: (row) => row?.CLOCK_IN,
      reorder: true,
      sortable: true,
    },
    {
      name: "Clock out",
      selector: (row) => row?.CLOCK_OUT,
      reorder: true,
      sortable: true,
    },
    {
      name: "Total Time",
      selector: (row) => row?.totalTime,
      reorder: true,
      sortable: true,
    },
  ];


  return (
    <>
      <Grid container>
        <Box
          onClick={() => navigate(-1)}
          sx={{ display: "flex", alignItems: "center", cursor: "pointer" }}>
          <IconButton>
            <ChevronLeftIcon />
          </IconButton>
          <Typography variant="body1">Back</Typography>
        </Box>

        <Grid item lg={12}>
          <Card>
            <Grid container lg={12}>
              <Grid item lg={6} p={2}>
                <Box>
                  <Typography
                    variant="h2"
                    pt={2}
                    style={{
                      fontWeight: 600,
                      fontSize: "20px",
                      color: "#000000",
                      opacity: "87%",
                    }}>
                    {jobData?.jobs_role?.ROLE_NAME}
                  </Typography>
                  <Typography
                    variant="h4"
                    pt={2}
                    style={{
                      fontWeight: 500,
                      fontSize: "16px",
                      color: "#000000",
                      opacity: "87%",
                    }}>
                    {new Date(jobData?.SERVICE_DATE).toDateString()}
                  </Typography>

                  {jobData?.SERVICE_TYPE === "Recurring" ? (
                    <>
                      {jobData?.SERVICE_DURATION?.map((jobdata) => (
                        <Box display="flex" gap={1}>
                          <Typography
                            variant="h2"
                            pt={2}
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#000000",
                              opacity: "60%",
                            }}>
                            <MdOutlineWatchLater />
                          </Typography>
                          <Typography
                            variant="h2"
                            pt={2}
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#000000",
                              opacity: "60%",
                            }}>
                            {jobdata?.JOB_DAY}
                          </Typography>
                          <Typography
                            variant="h2"
                            pt={2}
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#000000",
                              opacity: "60%",
                            }}>
                            {jobdata?.JOB_IN_TIME}
                          </Typography>
                          <Typography
                            variant="h2"
                            pt={2}
                            style={{
                              fontWeight: 400,
                              fontSize: "14px",
                              color: "#000000",
                              opacity: "60%",
                            }}>
                            {jobdata?.JOB_OUT_TIME}
                          </Typography>
                        </Box>
                      ))}
                    </>
                  ) : (
                    <>
                      <Box display="flex" gap={1}>
                        <Typography
                          variant="h2"
                          pt={2}
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "#000000",
                            opacity: "60%",
                          }}>
                          <MdOutlineWatchLater />
                        </Typography>
                        <Typography
                          variant="h2"
                          pt={2}
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "#000000",
                            opacity: "60%",
                          }}>
                          {new Date(
                            jobData?.job_services?.[0]?.JOB_IN_TIME
                          ).toLocaleTimeString()}
                        </Typography>{" "}
                        <Typography
                          variant="h2"
                          pt={2}
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "#000000",
                            opacity: "60%",
                          }}>
                          -
                        </Typography>
                        <Typography
                          variant="h2"
                          pt={2}
                          style={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: "#000000",
                            opacity: "60%",
                          }}>
                          {new Date(
                            jobData?.job_services[0]?.JOB_OUT_TIME
                          ).toLocaleTimeString()}
                        </Typography>
                      </Box>
                    </>
                  )}

                  <Typography
                    variant="h4"
                    pt={2}
                    style={{
                      fontWeight: 400,
                      fontSize: "14px",
                      color: "#000000",
                      opacity: "60%",
                    }}>
                    Glendora, CA
                  </Typography>
                </Box>
                <Box display="flex" gap={3} mt={2} justifyContent="start">
                  {jobData?.jobs_role?.ROLE_NAME && (
                    <Typography
                      style={{
                        backgroundColor: "#eef7e9",
                        borderRadius: "20px",
                        padding: "10px 20px",
                        color: "linear-gradient(to right,#4eb3e8,#6ebe44)",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}>
                      {jobData?.jobs_role?.ROLE_NAME}
                    </Typography>
                  )}
                  {jobData?.JOB_TYPE && (
                    <Typography
                      style={{
                        backgroundColor: "#eef7e9",
                        borderRadius: "20px",
                        padding: "10px 20px",
                        color: "linear-gradient(to right,#4eb3e8,#6ebe44)",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}>
                      {jobData?.JOB_TYPE}
                    </Typography>
                  )}
                  {jobData?.SERVICE_TYPE && (
                    <Typography
                      style={{
                        backgroundColor: "#eef7e9",
                        borderRadius: "20px",
                        padding: "10px 20px",
                        color: "linear-gradient(to right,#4eb3e8,#6ebe44)",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}>
                      {jobData?.SERVICE_TYPE}
                    </Typography>
                  )}
                </Box>
              </Grid>
              <Grid lg={6} item>
                {/* {checkStatus !== "offerAccept" &&
                                    <Box display="flex" mt={2} justifyContent="end" p={2}>
                                        <Grid mt={1}>
                                            <Typography style={{ backgroundColor: jobData?.JOB_STATUS === "Clinician Hired" ? 'linear-gradient(to right,#4eb3e8,#6ebe44)' : "#f6b613", borderRadius: "20px", padding: "1px 20px", color: "#ffffff", fontWeight: 500, fontSize: "14px" }}>{jobData?.JOB_STATUS}</Typography>
                                        </Grid>
                                        <IconButton p={0} onClick={handleClick}>
                                            <MoreHorizIcon />
                                        </IconButton>

                                    </Box>} */}
                <Menu
                  id="notification-menu"
                  anchorEl={anchorEl}
                  keepMounted
                  open={Boolean(anchorEl)}
                  // onClose={handleClose}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  sx={{
                    "& .MuiMenu-paper": {
                      width: "200px",
                      right: 0,
                      top: "70px !important",
                    },
                  }}>
                  {/* <MenuItem onClick={() => handleClose("Open for Applications")}>Open for Applications</MenuItem>
                                    <MenuItem onClick={() => handleClose("Clinician Hired")}>Clinician Hired</MenuItem> */}
                </Menu>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>

      <Grid mt={2}>
        <Card>
          <DataTable
            className="table-items"
            columns={columns}
            data={timeSheetData}
          // customStyles={customStyles}
          // onSort={handleSort}
          // sortServer
          />
        </Card>
      </Grid>

      {openPopup && (
        <Dialog
          open={openPopup}
          onClose={() => {
            handlePopupClose(false);
            view = false;
          }}
          maxWidth="md"
          fullWidth>
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "linear-gradient(to right,#4eb3e8,#6ebe44)",
              color: "#ffffff",
            }}>
            <DialogTitle mt={0.5} style={{ fontSize: "14px" }}>
              Create Shift
            </DialogTitle>
            <DialogTitle>
              {/* <CloseIcon onClick={handlePopupClose} style={{ color: "#ffffff", marginTop: 1, cursor: "pointer" }} /> */}
            </DialogTitle>
          </Box>

          <DialogContent>
            <form
            // onSubmit={handleSubmit(onSubmitAddShift)}
            >
              <Grid container spacing={2}>
                <Grid item lg={12}>
                  <DataTable
                    className="table-items"
                    columns={col}
                    data={rows}
                  // customStyles={customStyles}
                  // onSort={handleSort}
                  // sortServer
                  />
                </Grid>
                <Grid container display={"flex"} justifyContent={"end"}>
                  <Grid item lg={2} mt={1}>
                    <TextField
                      label="Total Time"
                      variant="outlined"
                      fullWidth
                      disabled
                      value={timeValiue}
                      autoFocus
                      // onChange={(e)=> setTimeEntryName(e.target.value)}
                      // value={watch('facilityName') || FACILITY_NAME}
                      sx={{
                        "& .MuiOutlinedInput-input": { padding: 1.814 },
                        "& .MuiFormHelperText-root": {
                          marginLeft: 0,
                          marginTop: "4px",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid container justifyContent={"center"}>
                  {approvedTimeSheet == "Approved" && (
                    <DialogTitle mt={0.5} style={{ fontSize: "14px" }}>
                      Time Sheet :{" "}
                      <span style={{ fontWeight: 700, color: "#71ba32" }}>
                        {" "}
                        Approved
                      </span>
                    </DialogTitle>
                  )}
                </Grid>

                <Grid container mt={1} justifyContent={"center"} gap={2}>
                  <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                      handlePopupClose(false);
                      view = false;
                    }}>
                    Cancel
                  </Button>
                  {approvedTimeSheet != "Approved" && (
                    <Button
                      variant="contained"
                      color="error"
                      onClick={() => {
                        approveTimeSheet();
                      }}>
                      Accept Time Sheet
                    </Button>
                  )}
                </Grid>
              </Grid>
            </form>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default ViewClinicianTimeSheet;
